import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API } from 'utils/globalApiServices';
import { toastFlashMessage } from 'utils';

const mutationFn = async ({ assignment_uuid, response_uuid, body = {} }) => {
  const url = `v3/roleplay-assignment/${assignment_uuid}/scenario-response/${response_uuid}/review/`;
  const data = await API.post(url, body);
  return data;
};

const useReviewScenarioMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: (response, data) => {
      toastFlashMessage(response?.message, 'success');
      queryClient.invalidateQueries(['REALPLAY_INFO', data?.assignment_uuid]);
    },
  });
};

export default useReviewScenarioMutation;
